/*
 * Copyright (c) 2022 automata-network/tgb-donation authors and contributors.
 * This software may be modified and distributed under the terms of MIT license.
 * Refer to the LICENSE file for details.
 */
import { GEODE_URL } from 'src/constants'
import { Nullable } from 'src/types/main'

export type DonorIdentityType = 'uen' | 'national_id'

export type DonorIdentity = {
  email: string
  ic_number: string
  name: string
  phone_number: string
  type: DonorIdentityType
}

export type DonorIdentityMutationResponse = {
  id: string
  type: 'customer_profile'
  attributes: {
    customer_name: string
    registration_id: string
    registration_type: DonorIdentityType
  }
}

export type LocalStorageDonorIdentityData = {
  user_info?: DonorIdentity
  user_profile_id?: string
}

/**
 * [setLocalStorageDonorIdentity description]
 * @type {[type]}
 */
export const setLocalStorageDonorIdentity = (data: Required<LocalStorageDonorIdentityData>) => {
  return localStorage.setItem('donorIdentity', JSON.stringify(data))
}

/**
 * [getLocalStorageDonorIdentity description]
 * @type {[type]}
 */
export const getLocalStorageDonorIdentity = () => {
  const data = localStorage.getItem('donorIdentity')
  const donorIdentity: Nullable<LocalStorageDonorIdentityData> = !data ? null : JSON.parse(data)

  return donorIdentity
}

/**
 * [async description]
 * @param {DonorIdentity} requestBody [description]
 */
export const postDonorIdentityRequest = async (requestBody: DonorIdentity) => {
  const request = new Request(`${GEODE_URL}/fiat-customer-profile`, {
    body: JSON.stringify(requestBody),
    headers: {
      'Content-Type': 'application/json'
    },
    method: 'POST'
  })

  return fetch(request)
}
